export const brandList3InitStory = {
  content: {
    body: [
      {
        component: "BrandList3",
        _uid: "1",
        brand_hero_link: { url: "" },
        brand_left_link: { url: "" },
        brand_hero_image: { filename: "" },
        brand_hero_title: "",
        brand_left_image: { filename: "" },
        brand_left_title: "",
        brand_right_link: { url: "" },
        brand_right_image: { filename: "" },
        brand_right_title: "",
      },
    ],
    component: "BrandsContainer",
  },
};

export const maternityHeaderInitStory = {
  content: {
    header: [
      {
        component: "CatalogLargeBanner",
        _uid: "1",
        catalog_large_banner_mobile: { filename: "" },
        catalog_large_banner_desktop: { filename: "" },
      },
    ],
    body: [
      {
        component: "CollectionList3",
        _uid: "2",
        collection_list_3_hero_link: { url: "" },
        collection_list_3_left_link: { url: "" },
        collection_list_3_hero_image: { filename: "" },
        collection_list_3_hero_title: "",
        collection_list_3_left_image: { filename: "" },
        collection_list_3_left_title: "",
        collection_list_3_right_link: { url: "" },
        collection_list_3_right_image: { filename: "" },
        collection_list_3_right_title: "",
      },
    ],
    component: "CatalogHeaderContainer",
  },
};
